import React from 'react';
import { useOutletContext, useParams, Link } from 'react-router-dom';
import SectionLabel from '../components/SectionLabel';
import Icon from '../components/Icon';
import SupplierAttendeeRow from '../components/SupplierAttendeeRow';
import Skeleton from '../components/Skeleton';
import { fetchSponsorDetail, useLive } from '../data/live';

export default function SponsorDetailPage() {
  const { meeting } = useOutletContext();
  const { companySlug } = useParams();
  const event = meeting._event;

  const detail = useLive(fetchSponsorDetail, [event?.id, companySlug]);

  if (detail === undefined) return <Skeleton variant="row" count={3} />;

  if (!detail) {
    return (
      <>
        <div className="portal-overview-body">
          Sponsor not found. <Link to="..">Back to Sponsors</Link>.
        </div>
      </>
    );
  }

  const attendees = detail.attendees || [];
  return (
    <>
      <div className="portal-sponsor-hero">
        {detail.logo && (
          <div className="portal-sponsor-hero-logo">
            <img src={detail.logo} alt={`${detail.name} logo`} />
          </div>
        )}
        <h1 className="portal-sponsor-hero-name">{detail.name}</h1>
      </div>

      <SectionLabel right={`${attendees.length}`}>
        Their team at {meeting.org}
      </SectionLabel>
      {attendees.length > 0 ? (
        <div className="portal-day-sessions">
          {attendees.map((a, i) => (
            <SupplierAttendeeRow key={i} attendee={a} />
          ))}
        </div>
      ) : (
        <div className="portal-overview-body">
          Attendee list coming soon.
        </div>
      )}

      {detail.website && (
        <a
          className="portal-sponsor-website"
          href={detail.website}
          target="_blank"
          rel="noreferrer"
        >
          Visit website <Icon name="external-link" size={14} />
        </a>
      )}
    </>
  );
}
